// extracted by mini-css-extract-plugin
export var leftAlign = "_2n-2";
export var popper = "_2n-0";
export var subtitle = "_2n-1";